import React, { useState } from "react";
import { colors } from "../../../themes/Colors";

const GhostButton = ({
  label,
  onClick,
  marginRight,
  width,
  borderColor,
  fontWeight,
  href,
}) => {
  const [hover, setHover] = useState(false);

  return (
    <a
      href={`${href}`}
      target={href ? "_blank" : null}
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      onClick={onClick}
      className="Button"
      style={{
        minWidth: width,
        width: width,
        borderRadius: 4,
        backgroundColor: hover ? colors.white : null,
        borderStyle: "solid",
        borderWidth: hover ? 2 : 0,
        borderColor: hover ? colors.secondary : borderColor,
        display: "flex",
        alignItems: "center",
        minHeight: 40,
        height: 40,
        marginRight: marginRight,
        cursor: "pointer",
        transition: "all 0.05s",
        textDecorationLine: "none",
        textDecoration: "none",
      }}
    >
      <h5
        style={{
          color: hover ? colors.secondary : borderColor,
          marginLeft: 10,
          fontWeight: fontWeight,
        }}
      >
        {label}
      </h5>
      <div style={{ flex: 1 }} />
      {hover ? (
        <img
          alt="arrow"
          src={require("../../../images/icons/arrowBlue.png")}
          style={{ marginRight: 10 }}
        />
      ) : (
        <img
          alt="arrow"
          src={require("../../../images/icons/arrowWhite.png")}
          style={{ marginRight: 10 }}
        />
      )}
    </a>
  );
};

export default GhostButton;
